import React from 'react';
import { View, StyleSheet } from 'react-native';
import { useQuery } from '@apollo/client';

import DataState from 'app/src/components/DataState';
import { elGray } from 'app/src/styles/colors';
import { Link } from 'app/src/utils/routing';

import SalesReport from './SalesReport';
import BuyerSummaryReport from './BuyerSummaryReport';
import InventoryReport from './InventoryReport';
import TitleStatusReport from './TitleStatusReport';
import TitlesToWorkReport from './TitlesToWorkReport';
import TitlesReceivedReport from './TitlesReceivedReport';
import MissingTitlesBySellerReport from './MissingTitlesBySellerReport';
import InvoicingReport from './InvoicingReport';
import IfSalesReport from './IfSalesReport';
import UnsoldAssetsReport from './UnsoldAssetsReport';
import SalesAndExpenseReport from './SalesAndExpenseReport';
import SellerDetailReport from './SellerDetailReport';
import AssetsSoldBySellerReport from './AssetsSoldBySellerReport';
import SoldByPaddleServiceReport from './SoldByPaddleServiceReport';
import AssetsByLocationReport from './AssetsByLocationReport';
import BlockReport from './BlockReport';
import SoldAssetsStatusReport from './SoldAssetsStatusReport';
import AssetsSoldSummary from './AssetsSoldSummary';
import SellerConfirmationReport from './SellerConfirmationReport';
import WebsiteBuyersReport from './WebsiteBuyersReport';
import FeesNotApprovedReport from './FeesNotApprovedReport';
import JournalEntryReport from './JournalEntryReport';
import ReversedEntryReports from './ReversedEntryReport';
import { REPORT_FILTERS } from './queries';

const Reports = () => {
  const { data, loading, error } = useQuery(REPORT_FILTERS);

  if (loading || !data) return <DataState.Loading />;
  if (error) return <DataState.Error error={error} />;

  return (
    <>
      <Link to={`/dashboard`}>
        <View style={{width: '100%', padding: '5px', backgroundColor: 'red', color: 'white', borderRadius: '10px'}}>
          Go to the Sellers Dashboard
        </View>
      </Link>
      <View style={styles.container}>
        <SalesReport data={data} />
        <BuyerSummaryReport data={data} />
        <InventoryReport data={data} />
        <TitleStatusReport data={data} />
        <TitlesReceivedReport data={data} />
        <MissingTitlesBySellerReport data={data} />
        <InvoicingReport data={data} />
        <IfSalesReport data={data} />
        <UnsoldAssetsReport data={data} />
        <SalesAndExpenseReport data={data} />
        <SellerDetailReport data={data} />
        <AssetsSoldBySellerReport data={data} />
        <SoldByPaddleServiceReport data={data} />
        <AssetsByLocationReport data={data} />
        <BlockReport data={data} />
        <SoldAssetsStatusReport data={data} />
        <AssetsSoldSummary data={data} />
        <SellerConfirmationReport data={data} />
        <WebsiteBuyersReport data={data} />
        <FeesNotApprovedReport data={data} />
        <JournalEntryReport data={data} />
        <ReversedEntryReports data={data} />
        <TitlesToWorkReport data={data} />
      </View>
    </>
  );
};

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'stretch',
    alignContent: 'stretch',
    marginTop: 20,
    backgroundColor: elGray,
    marginBottom: 20,
    marginLeft: 20,
    marginRight: 20,
  },
});

export const cardStyles = StyleSheet.create({
  container: {
    borderWidth: 1,
    borderColor: 'black',
    padding: 10,
    minWidth: 600,
    flex: 1,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 10,
  },
  note: {
    color: 'red',
    fontWeight: 800,
    marginBottom: 10,
  },
  label: {
    fontSize: 16,
    marginBottom: 5,
  },
  select: {
    borderWidth: 1,
    borderColor: 'gray',
    borderRadius: 5,
    marginBottom: 10,
    paddingHorizontal: 5,
    height: 25,
  },
});

export default Reports;
